import { render, staticRenderFns } from "./pointMap.vue?vue&type=template&id=b2c00494&scoped=true&"
import script from "./pointMap.vue?vue&type=script&lang=js&"
export * from "./pointMap.vue?vue&type=script&lang=js&"
import style0 from "./pointMap.vue?vue&type=style&index=0&id=b2c00494&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c00494",
  null
  
)

export default component.exports